import requests from "./httpService";

const PlanServices = {

    getPlan : async () =>{
        return requests.get(`/plan`);
    },
    updatePlan : async (id,body) =>{
       
        return requests.patch(`/plan/${id}`,body);
    },

    createPlan : async (body) =>{
   
        return requests.post(`/plan`,body);
    },
    deletePlan : async (id) =>{
        return requests.delete(`/plan/${id}`);
    },
    outofdeliveryVenderorder : async (id) =>{
        return requests.post(`booking/outofdeliveryVenderorder`);
    }
   

}

export default PlanServices;